/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hatarbeitserlaubnis1Inputs */



/**

* @param {_Field_Hatarbeitserlaubnis1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_hatarbeitserlaubnis1 = /** @type {((inputs?: _Field_Hatarbeitserlaubnis1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hatarbeitserlaubnis1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Benötigt Arbeitserlaubnis")
});
export { _field_hatarbeitserlaubnis1 as "_field_hatArbeitserlaubnis" }